import { Link, Outlet } from 'react-router-dom';
import Button from '../../../components/Button';
import { ChevronLeft } from 'react-feather';
import { RoutePaths } from '../../../config/routes';
import StepHeader from '../../../components/Navigation/StepHeader';
import StepWrapper from '../../../components/Step/Wrapper';
import FormLayout from '../../../components/Step/FormLayout';
import FormGrid from '../../../components/Step/FormGrid';
import FormCol from '../../../components/Step/FormCol';
import ReassuranceWrapper from '../../../components/Reassurance/Wrapper';
import ReassuranceItem from '../../../components/Reassurance/Item';
import Paragraph from '../../../components/Typography/Paragraph';
import { Handshake, Sparkle } from '../../../components/CustomIcon';
import Heading from "../../../components/Typography/Heading";
var SignUpVisitor = function () {
    return (<div className="flex w-full flex-col lg:h-screen">
      <StepHeader />
      <StepWrapper>
        <FormLayout>
          <FormGrid className="mb-10 lg:mb-20">
            <div className="items-center pt-10 lg:col-span-12 lg:grid lg:grid-cols-12 max-lg:flex">
              <Button type="inline" icon={ChevronLeft} side="start" className="mr-auto flex-1 text-gray-500 xl:col-span-2 max-lg:flex-none" to={RoutePaths.SIGN_IN_SITUATION}>
                <span className="max-sm:hidden lg:max-xl:hidden">Précédent</span>
              </Button>
            </div>
            <FormCol>
              <Outlet />
            </FormCol>
          </FormGrid>
        </FormLayout>
        <ReassuranceWrapper>
          <ReassuranceItem icon={Handshake}>
            <Heading level={6}>
              Pourquoi créer un compte visiteur·euse&nbsp;?
            </Heading>
            <Paragraph size="sm" className="mt-2">
              Pour accéder à une communauté de professionnel·le·s de la musique, explorer leurs profils et prendre contact avec eux.
            </Paragraph>
          </ReassuranceItem>
          <ReassuranceItem icon={Handshake}>
            <Heading level={6}>
              Qui peut s’inscrire en tant que visiteur·euse&nbsp;?
            </Heading>
            <Paragraph size="sm" className="mt-2">
              Toute personne (quel que soit son genre) qui souhaite collaborer ou interagir avec un·e membre de l’annuaire Majeur·e·s.{' '}
            </Paragraph>
          </ReassuranceItem>
          <ReassuranceItem icon={Sparkle}>
            <Heading level={6}>
              Je veux plutôt être référencé·e...
            </Heading>
            <Paragraph size="sm" className="mt-2">
              Dans ce cas, nous vous proposons de{' '}
              <Link to={RoutePaths.SIGN_UP_PROFESSIONAL}>
                <span className="underline">créer votre profil</span>
              </Link>{' '}
              sans plus attendre&nbsp;!
            </Paragraph>
          </ReassuranceItem>
        </ReassuranceWrapper>
      </StepWrapper>
    </div>);
};
export default SignUpVisitor;
